<template>
  <div class="player" v-if="currentPlayer">
    <a href="#" @click.prevent="$router.back()" class="back-link"></a>

    <div class="avatar" :style="{'background-image': 'url('+currentPlayer.image+')'}"></div>

    <h1>{{currentPlayer.name}}</h1>

    <div class="player-description" v-html="currentPlayer.description"></div>

  </div> 
</template>

<script>

  import {mapState} from 'vuex';

  export default {
    props: ['id'],
    data: function(){
      return {}
    }, 
    computed: {
      ...mapState(['currentPlayer'])
    }, 
    mounted: function(){
      if(this.$store.state.list.length){        
        this.$store.dispatch('currentPlayer', this.id)
      }else{
        this.$store.dispatch('fetchList').then(() => {
          this.$store.dispatch('currentPlayer', this.id)          
        })
      }

    }
  }
</script>